// NOTE: This should be 1:1 with `gatsby-ssr.js`!
exports.wrapPageElement = require('./dist/wrapPageElement').wrapPageElement;
